import React from "react";
import { Warnings } from "./components/warnings/Warnings";
import { additionalSearchLinkType, errorType, warningsType } from "../common/types/search/search";

/* eslint @typescript-eslint/no-require-imports: "off" */

interface NoSearchResultsProps {
	additionalSearchLink?: additionalSearchLinkType;
	error?: errorType;
	resultIsInvalid: boolean;
	warnings?: warningsType;
}

export function NoSearchResults({
	additionalSearchLink,
	error,
	resultIsInvalid,
	warnings,
}: NoSearchResultsProps) {
	const logo =
		require("../../../../www/static/img/icons/icon-no-search-results.svg") as string;

	const getNoResultsContent = () => {
		if (error || resultIsInvalid) {
			return (
				<>
					<h5>{error ? error.message : "Search request failed"}</h5>
					<p>
						Please change your search parameters or contact us on{" "}
						<a href="mailto: support@ch-aviation.com">
							support@ch-aviation.com
						</a>
						.
					</p>
				</>
			);
		}

		if (additionalSearchLink) {
			return additionalSearchLink;
		}

		return (
			<>
				<h5>No results</h5>
				<p>
					There are no results at the moment. <br />
					Start searching by filter.
				</p>
			</>
		);
	};

	return (
		<>
			<Warnings warnings={warnings} />
			<div className="no-search-results-wrapper">
				<div className="no-search-results grid">
					<img src={logo} alt="No results" />
					{getNoResultsContent()}
				</div>
			</div>
		</>
	);
}
